import { Params } from '@angular/router';
import { SidenavType } from '@app/core/sidenav-type';
import { RightsConst } from '@pezi/entities';

export interface GlobalNavGroup {
  header: string;
  id: string;
  expanded: boolean;
  order?: number;
}

export const navGroup_divers: GlobalNavGroup = {
  header:   'Diverses',
  id:       'diverses',
  expanded: false,
  order:    1
};

export const navGroup_suche: GlobalNavGroup = {
  header:   'Suche',
  id:       'suche',
  expanded: true,
  order:    0
};

export const navGroup_makler_divers: GlobalNavGroup = {
  header:   'Diverses',
  id:       'maklerdivers',
  expanded: true,
  order:    3
};

export const navGroup_makler_suche: GlobalNavGroup = {
  header:   'Suche',
  id:       'maklersuche',
  expanded: true,
  order:    2
};

export const navGroup_admin: GlobalNavGroup = {
  header:   'Administration',
  id:       'admin',
  expanded: false,
  order:    4
};

export const globalDrawerItems: GlobalNavCategory[] = [
  {
    id:        99,
    routerUrl: '/form-demo',
    icon:      'grade',
    devOnly:   true,
    header:    'Form Demo'
  },
  {
    id:                    1,
    routerUrl:             '/person',
    icon:                  'person_pin',
    right:                 RightsConst.PZ_PERSON,
    header:                'Person',
    possibleChildSideNavs: [
      SidenavType.PERSON,
      SidenavType.BEITRAGSZAHLER,
      SidenavType.VERSPERSON
    ],
    defaultNavBox:         true,
    group:                 navGroup_suche
  },
  {
    id: 55,
    routerUrl:             '/maklerperson',
    icon:                  'person_pin',
    right:                 RightsConst.PZ_MAKLER_PERSON,
    header:                'Person',
    possibleChildSideNavs: [SidenavType.MAKLERPERSON],
    defaultNavBox:         true,
    group:                 navGroup_makler_suche
  },
  {
    id:                    2,
    routerUrl:             '/polizze',
    icon:                  'description',
    right:                 RightsConst.PZ_POLIZZE,
    header:                'Polizzen- Kennzeichen',
    possibleChildSideNavs: [
      SidenavType.POLIZZE,
      SidenavType.VERTRAG,
      SidenavType.POSITION,
      SidenavType.ZAHLUNG,
      SidenavType.POLIZZEBUCHUNG
    ],
    defaultNavBox:         true,
    group:                 navGroup_suche
  },
  {
    id:                    27,
    routerUrl:             '/maklerpolizze',
    icon:                  'description',
    right:                 RightsConst.PZ_MAKLER_POLIZZEN,
    header:                'Polizzen/KFZ-Kennzeichen',
    possibleChildSideNavs: [
      SidenavType.MAKLERPOLIZZE
    ],
    defaultNavBox:         true,
    group:                 navGroup_makler_suche
  },
  {
    id:                    5,
    routerUrl:             '/haushalt',
    icon:                  'home_work',
    right:                 RightsConst.PZ_HAUSHALT,
    header:                'Haushalt',
    possibleChildSideNavs: [SidenavType.HAUSHALT],
    group:                 navGroup_suche
  },
  {
    id:                    14,
    routerUrl:             '/verbund',
    icon:                  'groups',
    right:                 RightsConst.PZ_VERBUND,
    header:                'Verbund',
    possibleChildSideNavs: [SidenavType.VERBUND],
    group:                 navGroup_suche
  },
  {
    id:                    4,
    routerUrl:             '/schaden',
    icon:                  'quickreply',
    right:                 RightsConst.PZ_SCHADEN,
    header:                'Schaden',
    possibleChildSideNavs: [SidenavType.SCHADEN],
    group:                 navGroup_suche
  },
  {
    id:                    28,
    routerUrl:             '/maklerschaden',
    icon:                  'quickreply',
    right:                 RightsConst.PZ_MAKLER_SCHADEN,
    header:                'Schaden',
    possibleChildSideNavs: [
      SidenavType.MAKLERSCHADEN
    ],
    defaultNavBox:         true,
    group:                 navGroup_makler_suche
  },
  {
    id:        54,
    routerUrl: '/maklerfamilienpass',
    icon:      'family_restroom',
    right:     RightsConst.PZ_MAKLER_FAMILIENPASS,
    header:    'Familienpass',
    possibleChildSideNavs: [SidenavType.MAKLERFAMILIENPASS],
    group:     navGroup_makler_suche
  },
  {
    id:                    22,
    routerUrl:             '/schadenbeteiligter',
    icon:                  'group_add',
    right:                 RightsConst.PZ_SCH_BETEIL,
    header:                'Schadenbeteiligter',
    possibleChildSideNavs: [SidenavType.SCHADENBETEILIGTER],
    group:                 navGroup_suche
  },
  {
    id:                    3,
    routerUrl:             '/fahrzeug',
    icon:                  'directions_car',
    right:                 RightsConst.PZ_FAHRZEUG,
    header:                'Fahrzeug',
    possibleChildSideNavs: [SidenavType.FAHRZEUG],
    group:                 navGroup_suche
  },
  {
    id:                    23,
    routerUrl:             '/zulassung',
    icon:                  'approval',
    right:                 RightsConst.PZ_ZULASSUNG,
    header:                'Zulassungen',
    possibleChildSideNavs: [
      SidenavType.ZULASSUNG,
      SidenavType.ZULASSUNG_KENNZEICHEN
    ],
    group:                 navGroup_suche
  },
  {
    id:                    8,
    routerUrl:             '/vsb',
    icon:                  'fact_check',
    right:                 RightsConst.PZ_VSB,
    header:                'Vers. Bestätigung',
    possibleChildSideNavs: [SidenavType.VSB],
    group:                 navGroup_suche
  },
  {
    id:                    6,
    routerUrl:             '/gebaeude',
    icon:                  'house',
    right:                 RightsConst.PZ_GEBAEUDE,
    header:                'Gebäude',
    possibleChildSideNavs: [SidenavType.GEBAEUDE],
    group:                 navGroup_suche
  },
  {
    id:                    15,
    routerUrl:             '/maklerknoten',
    icon:                  'join_full',
    right:                 RightsConst.PZ_BETREUER_KNOTEN,
    header:                'Maklerknoten',
    possibleChildSideNavs: [SidenavType.BETREUERKNOTEN],
    group:                 navGroup_suche
  },
  {
    id:                    9,
    routerUrl:             '/betreuer',
    icon:                  'people',
    right:                 RightsConst.PZ_BETREUER,
    header:                'Betreuer',
    possibleChildSideNavs: [SidenavType.BETREUER],
    group:                 navGroup_suche
  },
  {
    id:                    10,
    routerUrl:             '/vertreter',
    icon:                  'business_center',
    right:                 RightsConst.PZ_VERTRETER,
    header:                'Vertreter',
    possibleChildSideNavs: [SidenavType.VERTRETER],
    group:                 navGroup_suche
  },
  {
    id:                    31,
    routerUrl:             '/maklervertreter',
    icon:                  'business_center',
    right:                 RightsConst.PZ_MAKLER_PROVKONTEN,
    header:                'Provisionskonten',
    possibleChildSideNavs: [
      SidenavType.MAKLERVERTRETER
    ],
    group:                 navGroup_makler_suche
  },
  {
    id:        34,
    routerUrl: '/maklerkontakte',
    icon:      'contact_page',
    right:     RightsConst.PZ_MAKLER,
    header:    'Ansprechpartner',
    group:     navGroup_makler_divers
  },
  {
    id:        37,
    routerUrl: '/maklerdocuments/list',
    icon:      'download',
    right:     RightsConst.PZ_MAKLER,
    header:    'Downloadbereich',
    possibleChildSideNavs: [SidenavType.MAKLERDOWNLOAD],
    group:     navGroup_makler_divers
  },
  {
    id:        43,
    routerUrl: '/maklertarife',
    icon:      'contact_page',
    right:     RightsConst.PZ_MAKLER,
    header:    'Tarife',
    group:     navGroup_makler_divers
  },
  {
    id:                    26,
    routerUrl:             '/bezugsberechtigter',
    icon:                  'transfer_within_a_station',
    right:                 RightsConst.PZ_PERSON_BBR,
    header:                'Bezugsberechtigter',
    possibleChildSideNavs: [SidenavType.BEZUGSBERECHTIGTER],
    group:                 navGroup_suche
  },
  {
    id:                    20,
    routerUrl:             '/schadenzahlungempf',
    icon:                  'payment',
    right:                 RightsConst.PZ_SCHZAHLEMPF,
    header:                'Zahlungsempfänger',
    possibleChildSideNavs: [SidenavType.SCHADENZAHLUNGEMPF],
    group:                 navGroup_suche
  },
  {
    id:                    16,
    routerUrl:             '/texte',
    icon:                  'text_snippet',
    right:                 RightsConst.PZ_TEXTE,
    header:                'Klausel/AVB/Text',
    possibleChildSideNavs: [SidenavType.TEXTE],
    group:                 navGroup_suche
  },
  {
    id:                    17,
    routerUrl:             '/familienpass',
    icon:                  'family_restroom',
    right:                 RightsConst.PZ_FAMILIENPASS,
    header:                'Familienpass',
    possibleChildSideNavs: [SidenavType.FAMILIENPASS],
    group:                 navGroup_suche
  },
  {
    id:                    7,
    routerUrl:             '/hotline',
    icon:                  'phone',
    right:                 RightsConst.PZ_HOTLINE,
    header:                'Kundenauskunft',
    possibleChildSideNavs: [SidenavType.HOTLINE],
    defaultNavBox:         true,
    group:                 navGroup_suche
  },
  {
    id:                    13,
    routerUrl:             '/assistance',
    icon:                  'support_agent',
    right:                 RightsConst.PZ_ASSISTANCE,
    header:                'Assistance',
    possibleChildSideNavs: [
      SidenavType.ASSISTANCE,
      SidenavType.ASSISTANCEPOLIZZE
    ],
    group:                 navGroup_suche
  },
  {
    id:        12,
    routerUrl: '/partneradmin',
    icon:      'assignment_ind',
    right:     [
      RightsConst.PZ_PARTNERADMIN,
      RightsConst.PZ_PARTNERADMIN_READ
    ],
    rightsLinkedAsOR: true,
    header:    'Partnerverwaltung',
    group:     navGroup_admin
  },
  {
    id:        40,
    routerUrl: '/maklerpartneradmin',
    icon:      'assignment_ind',
    right:     RightsConst.PZ_MAKLER_USERADMIN,
    header:    'Portaladministration',
    group:     navGroup_admin
  },
  {
    id:                    18,
    routerUrl:             '/partner',
    icon:                  'connect_without_contact',
    right:                 RightsConst.PZ_PARTNER,
    header:                'Partner',
    possibleChildSideNavs: [SidenavType.PARTNER],
    group:                 navGroup_suche
  },
  {
    id:        59,
    routerUrl: '/beratungsleitfaden',
    icon:      'menu_book',
    right:     RightsConst.PZ_BERATUNGSLEITFADEN,
    header:    'Beratungsleitfäden',
    group:     navGroup_divers
  },
  {
    id:        19,
    routerUrl: '/index',
    icon:      'list',
    right:     RightsConst.PZ_INDEX,
    header:    'Index',
    group:     navGroup_divers
  },
  {
    id:        21,
    routerUrl: '/ungeklaertezahlungen',
    icon:      'sync_problem',
    right:     RightsConst.PZ_ZAHLUNGEN,
    header:    'Ungeklärte Zahlungen',
    group:     navGroup_divers
  },
  {
    id:        24,
    routerUrl: '/banktag',
    icon:      'today',
    right:     RightsConst.PZ_ZAHLUNGEN,
    header:    'Banktag',
    group:     navGroup_divers
  },
  {
    id:        25,
    routerUrl: '/svsterbetabelle',
    icon:      'badge',
    right:     RightsConst.PZ_SVS,
    header:    'SV-Meldung',
    group:     navGroup_divers
  },
  {
    id:                    11,
    routerUrl:             '/benutzer',
    icon:                  'admin_panel_settings',
    right:                 RightsConst.PZ_ADMIN,
    header:                'Benutzeradministration',
    possibleChildSideNavs: [SidenavType.BENUTZER],
    group:                 navGroup_admin
  },
  {
    id:     56,
    routerUrl: '/intranetuser',
    icon:   'manage_accounts',
    right:  RightsConst.PZ_ADMIN,
    header: 'Intranet User',
    group:  navGroup_admin
  },
  {
    id:        29,
    routerUrl: '/nichtabgestattet',
    icon:      'request_quote',
    right:     RightsConst.PZ_ZAHLUNGEN,
    header:    'Noch nicht abgestattet',
    group:     navGroup_divers
  },
  {
    id:        32,
    routerUrl: '/genehmigung',
    icon:      'approval',
    right:     RightsConst.GENEHM,
    header:    'Genehmigung',
    group:     navGroup_divers
  },
  {
    id:        33,
    routerUrl: '/gehaltsumwandlung',
    icon:      'currency_exchange',
    right:     RightsConst.PZ_GEHALTSUMW,
    header:    'Gehaltsumwandlung',
    group:     navGroup_divers
  },
  {
    id:        35,
    routerUrl: '/archivadmin',
    icon:      'move_to_inbox',
    right:     RightsConst.PZ_ARCHIVADMIN,
    header:    'Archiv Admin',
    group:     navGroup_admin
  },
  {
    id:        36,
    routerUrl: '/motorsteuer',
    icon:      'directions_car',
    right:     RightsConst.PZ_MOTORSTEUER,
    header:    'Motorsteuer',
    group:     navGroup_divers
  },
  {
    id:        44,
    routerUrl: '/kundenkarte',
    icon:      'map',
    right:     RightsConst.PZ_KND_KARTE,
    header:    'Kundenkarte',
    group:     navGroup_divers
  },
  {
    id:        45,
    routerUrl: '/kundengeburtstag',
    icon:      'cake',
    right:     RightsConst.PZ_KND_GEBDAT,
    header:    'Kundengeburtstag',
    group:     navGroup_divers
  },
  {
    id:        39,
    routerUrl: '/maklerindex',
    icon:      'list',
    right:     RightsConst.PZ_MAKLER,
    header:    'Index',
    group:     navGroup_makler_divers
  },
  {
    id:        38,
    routerUrl: '/maklermotorsteuer',
    icon:      'directions_car',
    right:     RightsConst.PZ_MAKLER,
    header:    'Motorsteuer',
    group:     navGroup_makler_divers
  },
  {
    id:        41,
    routerUrl: '/kostenstellen',
    icon:      'monetization_on',
    right:     RightsConst.PZ_ADMIN,
    header:    'Kostenstellen',
    group:     navGroup_admin
  },
  {
    id:        42,
    routerUrl: '/maklermahnstand',
    icon:      'assignment_late',
    right:     RightsConst.PZ_MAKLER_POLIZZEN,
    header:    'Mahnstandpolizzen',
    group:     navGroup_makler_divers
  },
  {
    id:        46,
    routerUrl: '/makleroffertprogramm',
    icon:      'exit_to_app',
    right:     RightsConst.PZ_MAKLER_OFFERT,
    header:    'Offertprogramm',
    group:     navGroup_makler_divers
  },
  {
    id:        48,
    routerUrl: '/maklerexcel',
    icon:      'calculate',
    right:     RightsConst.PZ_MAKLER_EXCELRECHNER,
    header:    'Excelrechner',
    group:     navGroup_makler_divers
  },
  {
    id:                    44,
    routerUrl:             '/rkw',
    icon:                  'savings',
    right:                 RightsConst.PZ_RKW,
    header:                'Rückkaufswerte',
    group:                 navGroup_divers,
    possibleChildSideNavs: [SidenavType.RKW]
  },
  {
    id:        47,
    routerUrl: '/zahlungslimitadmin',
    icon:      'price_change',
    right:     RightsConst.PZ_SCHZAHLADMIN,
    header:    'Zahlungsfreigabe Admin',
    group:     navGroup_admin
  },
  {
    id:                    49,
    routerUrl:             '/cms/maklerdoc',
    icon:                  'difference',
    right:                 RightsConst.PZ_MAKLERDOCADMIN, // TODO add CMS Right
    header:                'Maklerdokumente verwalten',
    group:                 navGroup_admin,
    possibleChildSideNavs: [SidenavType.CMS]
  },
  {
    id:        50,
    routerUrl: '/referate',
    icon:      'person_search',
    right:     RightsConst.PZ_REFERATE,
    header:    'Referate ermitteln',
    group:     navGroup_divers
  },
  {
    id:        51,
    routerUrl: '/mahnstand',
    icon:      'assignment_late',
    right:     RightsConst.PZ_MAHNSTAND,
    header:    'Mahnstandpolizzen',
    group:     navGroup_divers
  },
  {
    id:        52,
    routerUrl: '/datenschutz',
    icon:      'shield',
    right:     RightsConst.PZ_DATENSCHUTZ,
    header:    'Datenschutz',
    possibleChildSideNavs: [SidenavType.DATENSCHUTZ],
    group:     navGroup_suche
  },
  {
    id:                    53,
    routerUrl:             '/kundendatenadmin',
    icon:                  'groups_3',
    right:            [
      RightsConst.PZ_KNDA_ZUSA,
      RightsConst.PZ_KNDA_KUML
    ],
    rightsLinkedAsOR: true, // Entweder PZ_KNDA_ZUSA oder PZ_KNDA_KUML
    header:                'Kundendatenverwaltung',
    possibleChildSideNavs: [SidenavType.KUNDENDATENADMIN],
    group:                 navGroup_admin
  },
  {
    id:                    58,
    routerUrl:             '/betreuerdatenadmin',
    icon:                  'settings_accessibility',
    header:                'Betreuerdatenadmin',
    right:                 RightsConst.PZ_BETDA,
    possibleChildSideNavs: [SidenavType.BETREUERDATENARCHIVADMIN],
    group:                 navGroup_admin
  },
  {
    id:                    60,
    routerUrl:             '/referatadmin',
    icon:                  'social_distance',
    header:                'Referatsverwaltung',
    right:                 RightsConst.PZ_REFERATADMIN,
    possibleChildSideNavs: [SidenavType.REFERATADMIN],
    group:                 navGroup_admin
  },
  {
    id:     57,
    routerUrl: '/vsb-forward',
    icon:   'verified_user',
    right:  RightsConst.PZ_VERSBEST,
    header: 'VB drucken',
    group:  navGroup_divers
  },
  {
    id:        61,
    routerUrl: '/maklervsb',
    icon:      'verified_user',
    header: 'Vers.bestätigung Drucken',
    right:     RightsConst.PZ_MAKLER,
    group:     navGroup_makler_divers
  }
];

export interface GlobalNavCategory {
  id: number;
  routerUrl: string;
  icon: string;
  devOnly?: boolean;
  header: string;
  right?: string | string[];
  rightsLinkedAsOR?: boolean; // Sind die Rechte Oder-Verknüpft (Default "und")
  possibleChildSideNavs?: SidenavType[];
  defaultNavBox?: boolean; // Default Box on Home page
  group?: GlobalNavGroup;
}

export interface SubItemCategory {
  subItems: Navitem[];
  header?: string;
  icon?: string;
  clickableHeader?: Navitem;
}

export interface Navitem {
  name: string;
  subtitle?: string;
  routerUrl?: string;
  icon?: string;
  children?: Navitem[];
  expanded?: boolean;
  queryParams?: Params;
  dynamicURLPart?: string;
  devOnly?: boolean;
  right?: RightsConst | RightsConst[];
  rightsLinkedAsOR?: boolean; // Sind die Rechte Oder-Verknüpft (Default "und")
  isDefault?: boolean;
  hidden?: boolean;
  disabled?: boolean;
  id?: string;
  newTabUrlFull?: string;
  showInFastActionBar?: boolean;
  openDialog?: Function;
  externalUrl?: string;
}
